export default "__VITE_ASSET__ChMkZ8ut__"